import "../../sass/pages/_mcp.scss";
import SamplePromptsTabs from "../components/mcp/sample-prompts-tabs";
import McpTestimonialsSlider from "../components/mcp/mcp-testimonials-slider";
import HowItWorksSlider from "../components/mcp/how-it-works-slider";
import WorksWithSlider from "../components/mcp/works-with-slider";
import TypingText from "../components/typing-text";
import McpVeryKv from "../components/mcp/very-kv";

import CollapseEntry from "../../js/components/collapse-entry";

document.addEventListener('DOMContentLoaded', () => {
    window.customElements.define('sample-prompts-tabs', SamplePromptsTabs);
    window.customElements.define('mcp-testimonials-slider', McpTestimonialsSlider);
    window.customElements.define('how-it-works-slider', HowItWorksSlider);
    window.customElements.define('works-with-slider', WorksWithSlider);
    window.customElements.define('typing-text', TypingText);
    window.customElements.define('mcp-very-kv', McpVeryKv);

    new CollapseEntry(".collapse-entry");
});
